import React, { useEffect, useRef, useState } from 'react';
import { ICms } from '@/types/cms';
import { ErrorBoundary } from 'react-error-boundary';
import { isSayWeeeApp } from '@/utils/tool';
import CmsComponentRenderer from './CmsComponentRenderer';

const CmsRender: React.FC<{
  sections: ICms['layout']['sections'];
  datasource: ICms['datasource'];
  trackingContext: { [key: string]: unknown };
  staticRes: { [key: string]: unknown };
  statusBarHeight?: number;
  isPreview?: boolean;
}> = props => {
  const { sections, datasource, trackingContext, staticRes, statusBarHeight, isPreview } = props;
  const [top, setTop] = useState<number>(0);

  const handleTimeBannerChange = () => {
    if (!isSayWeeeApp()) {
      // 查找同时满足下面的条件，保证是当前显示的是cms页面才更改top
      const keepaliveElement = document.querySelector(
        'div[data-keepalive*="cms-activity-page"][data-keepalive-hidden="false"]'
      );
      if (keepaliveElement) {
        const topHeight = keepaliveElement.querySelector('#layout-header')?.clientHeight - 1 || 0;
        setTop(topHeight);
      }
    } else {
      setTop(statusBarHeight + 48);
    }
  };

  useEffect(() => {
    handleTimeBannerChange();
    window.addEventListener('new-user-banner-change', handleTimeBannerChange);
    return () => {
      window.removeEventListener('new-user-banner-change', handleTimeBannerChange);
    };
  }, []);

  const uniqueVideoPlayerRef = useRef(null);

  return (
    <>
      {sections.map(section => {
        return (
          <React.Fragment key={section.section_key}>
            {section.components.map((component, index) => (
              <React.Fragment key={component.component_instance_key}>
                <ErrorBoundary
                  key={`${component.component_key}_${index}`}
                  fallback={<div data-error={component.component_key}></div>}>
                  <CmsComponentRenderer
                    component={component}
                    index={index}
                    datasource={datasource}
                    trackingContext={trackingContext}
                    staticRes={staticRes}
                    sections={sections}
                    top={top}
                    isPreview={isPreview}
                    uniqueVideoPlayerRef={uniqueVideoPlayerRef}
                  />
                </ErrorBoundary>
              </React.Fragment>
            ))}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default CmsRender;
